export default __webpack_public_path__ + "static/media/img-mwa-5-video-poster.c8d42f2d.png";